import { ReactNode } from 'react';
import { create } from 'zustand';

export type TBreadcrumbItem = {
  label: string;
  to?: string;
  state?: Record<string, unknown>;
};

interface IPageTitleState {
  title: string;
  setTitle: (title: string) => void;
  breadcrumb: TBreadcrumbItem[];
  setIsBreadcrumb: (content: TBreadcrumbItem[]) => void;
  customContent: ReactNode;
  setCustomContent: (content: ReactNode) => void;
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  buttonData: ReactNode;
  setButtonData: (buttonData: ReactNode) => void;
}

const usePageTitle = create<IPageTitleState>((set) => ({
  title: 'Dashboard ',
  setTitle: (title) => set({ title }),
  breadcrumb: [],
  setIsBreadcrumb: (content) => set({ breadcrumb: content }),
  customContent: null,
  setCustomContent: (content) => set({ customContent: content }),
  collapsed: false,
  setCollapsed: (collapsed) => set({ collapsed: collapsed }),
  buttonData: null,
  setButtonData: (buttonData: ReactNode) => {
    set({ buttonData });
  },
}));

export default usePageTitle;
